<div uipagebookmarkheader>
  <span uipagebookmarktitle>Contents</span>
</div>
<div uipagebookmarkcontent>
  <div uipagebookmarkitem title="Top" (click)="layout.jumpToAnchor()">
    <span>Top</span>
  </div>
  @if (layout.layoutIsReady()) {
    @for (anchor of layout.anchors(); track $index) {
      @if (anchor.ref.nativeElement.checkVisibility()) {
        <div
          uipagebookmarkitem
          [attr.title]="anchor.tag"
          (click)="layout.jumpToAnchor(anchor.ref, anchor.offset)"
        >
          <span>{{ anchor.tag }}</span>
        </div>
      }
    }
  }
</div>
